module.exports = __webpack_public_path__ + "static/media/Bus Stop Mockup.c404bb65.png";